import React, { useMemo, useState } from 'react';

import { needsEmbedding } from './contentCheck';
import { Markdown, Toggle } from '../../components';

type MessageContentProps = {
  content: string;
  isComplex: boolean;
};

type ComplexMessageProps = Pick<MessageContentProps, 'content'>;

const ComplexMessage: React.FC<ComplexMessageProps> = ({ content }) => {
  const [title] = useState(() => crypto.randomUUID());
  const [showComplex, setShowComplex] = useState(true);
  const isEmbedded = useMemo(() => needsEmbedding(content), [content]);

  return (
    <div className="relative">
      <div className="flex justify-end mb-md">
        <Toggle
          label="View Raw"
          value={!showComplex}
          labelClass="text-tiny"
          onChange={() => setShowComplex(e => !e)}
        />
      </div>
      <div className="overflow-auto">
        {showComplex ? (
          isEmbedded ? (
            <iframe
              title={title}
              className="flex-grow"
              srcDoc={content}
              style={{
                border: 0,
                width: '100%',
                minHeight: 500,
              }}
              sandbox="allow-same-origin allow-scripts"
            />
          ) : (
            <Markdown children={content} />
          )
        ) : (
          content
        )}
      </div>
    </div>
  );
};

const MessageContent: React.FC<MessageContentProps> = ({
  content,
  isComplex,
}) => {
  if (!isComplex) return content;

  return <ComplexMessage content={content} />;
};

export default React.memo(MessageContent) as typeof MessageContent;
